module.exports = __webpack_public_path__ + "img/Homework fail 1.fc39d52a.png";